var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 113 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5918 16.023C61.5918 9.30954 67.2358 4.94287 75.4048 4.94287C82.742 4.94287 88.0889 8.59668 88.6831 13.6169H83.8114C83.3361 11.2405 80.2467 8.83432 75.4048 8.83432C69.9389 8.83432 66.3743 11.8346 66.3743 16.0231C66.3743 20.271 69.9389 23.2711 75.4048 23.2711C80.2467 23.2711 83.3361 20.865 83.8114 18.4589H88.6831C88.0889 23.5385 82.742 27.1922 75.4048 27.1922C67.2358 27.1922 61.5918 22.7958 61.5918 16.023Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.338 5.47754H96.9423V22.677H112.448V26.598H92.3379L92.338 5.47754Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1543 4.8457V27.1533C30.1349 24.3667 32.0004 20.402 32.0004 15.9995C32.0004 11.597 30.1349 7.63239 27.1543 4.8457Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84609 27.1534V4.8457C1.8655 7.63246 0 11.5971 0 15.9995C0 20.402 1.8655 24.3667 4.84609 27.1534Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8457 4.84609H27.1533C24.3667 1.8655 20.402 0 15.9996 0C11.5972 0 7.63239 1.8655 4.8457 4.84609Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1534 27.1538H4.8457C7.63239 30.1344 11.597 31.9999 15.9995 31.9999C20.4019 31.9999 24.3667 30.1344 27.1534 27.1538Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4902 4.8457V27.1533C52.4708 24.3667 54.3363 20.402 54.3363 15.9995C54.3363 11.597 52.4708 7.63239 49.4902 4.8457Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.182 27.1534V4.8457C24.2014 7.63239 22.3359 11.597 22.3359 15.9995C22.3359 20.402 24.2014 24.3667 27.182 27.1534Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1816 4.84609H49.4893C46.7026 1.8655 42.7379 0 38.3355 0C33.9331 0 29.9683 1.8655 27.1816 4.84609Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4893 27.1538H27.1816C29.9683 30.1344 33.933 31.9999 38.3355 31.9999C42.7379 31.9999 46.7026 30.1344 49.4893 27.1538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClLogo);
export default __webpack_public_path__ + "static/media/cl-logo.29c47748fb19d71409701eba8b5fee29.svg";
export { ForwardRef as ReactComponent };